import React from 'react';
import { MinervaLogo } from './MinervaLogo';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, MapPin, FileText, LayoutGrid, ClipboardCheck } from 'lucide-react';
interface TopBarProps {
  onBack?: () => void;
  onSkip?: () => void;
  onOpenMap?: () => void;
  onOpenStoryboard?: () => void;
  onOpenVisualStoryboard?: () => void;
  onOpenSupportChecklist?: () => void;
}
export function TopBar({
  onBack,
  onSkip,
  onOpenMap,
  onOpenStoryboard,
  onOpenVisualStoryboard,
  onOpenSupportChecklist
}: TopBarProps) {
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} className="absolute top-0 left-0 right-0 px-5 py-4 flex justify-between items-center z-30" data-id="element-345">
      <div className="flex items-center gap-3" data-id="element-346">
        {onBack && <button onClick={onBack} className="flex items-center justify-center w-8 h-8 rounded-full bg-white/80 border border-slate-200 text-slate-600 backdrop-blur-md shadow-sm hover:bg-white transition-colors shrink-0" aria-label="Go back" data-id="element-347">
            <ChevronLeft size={18} data-id="element-348" />
          </button>}
        <MinervaLogo className="shrink-0" data-id="element-349" />
      </div>

      <div className="flex items-center gap-2" data-id="element-350">
        {onOpenStoryboard && <button onClick={onOpenStoryboard} className="flex items-center justify-center w-8 h-8 rounded-full bg-white/80 border border-slate-200 text-slate-600 backdrop-blur-md shadow-sm hover:bg-white transition-colors shrink-0" aria-label="View Brief" data-id="element-351">
            <FileText size={16} data-id="element-352" />
          </button>}

        {onOpenMap && <button onClick={onOpenMap} className="flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-full bg-white/80 border border-slate-200 backdrop-blur-md shadow-sm hover:bg-white transition-colors shrink-0" data-id="element-353">
            <MapPin size={12} className="text-minerva-blue" data-id="element-354" />
            <span className="text-[10px] font-semibold text-slate-600 tracking-widest uppercase hidden sm:inline-block" data-id="element-355">
              Booth #1762
            </span>
            <span className="text-[10px] font-semibold text-slate-600 tracking-widest uppercase sm:hidden" data-id="element-356">
              Booth
            </span>
          </button>}
        {onSkip && <button onClick={onSkip} className="flex items-center gap-1 px-2.5 sm:px-3 py-1.5 rounded-full bg-white/80 border border-slate-200 text-slate-600 backdrop-blur-md shadow-sm hover:bg-white transition-colors text-[10px] font-semibold tracking-widest uppercase shrink-0" data-id="element-357">
            Skip
            <ChevronRight size={14} data-id="element-358" />
          </button>}
      </div>
    </motion.div>;
}